import { observer } from 'mobx-react'
import styled from 'styled-components'
type Props = {
  type?: 'blue' | 'red' | 'gray' | 'black' | 'lightBlue' | 'lightRed'
}
export const Chip: React.FC<Props> = observer(({ children, type }) => {
  return (
    <StyleBadge color={`${type}`}>
      <span>{children}</span>
    </StyleBadge>
  )
})
const StyleBadge = styled.div`
  min-width: 60px;
  max-height: 18px;
  font-size: 11px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) =>
    props.color === 'blue'
      ? '#ffffff'
      : props.color === 'red'
      ? '#ffffff'
      : props.color === 'gray'
      ? '#ffffff'
      : props.color === 'black'
      ? '#ffffff'
      : props.color === 'lightBlue'
      ? '#3B82F6'
      : props.color === 'lightRed'
      ? '#EA4E3D'
      : '#ffffff'};
  background-color: ${(props) =>
    props.color === 'blue'
      ? '#3B82F6'
      : props.color === 'red'
      ? '#EA4E3D'
      : props.color === 'gray'
      ? '#CCCCCC'
      : props.color === 'black'
      ? '#000000'
      : props.color === 'lightBlue'
      ? '#CAE0FF'
      : props.color === 'lightRed'
      ? '#FFC6C2'
      : '#CCCCCC'};
  border-radius: 7px;
`
